export const BITSAT_TEST_INSTRUCTION_PATH = "/bitsat/test_Instruction";

export const isBitsatExam = (details = {}) => {
  if (details?.source === "bitsat") return true;

  return /bitsat/i.test(
    [
      details?.test_name,
      details?.paper_name,
      details?.testName,
      details?.name,
      details?.test_type,
      details?.paper_type,
    ]
      .filter(Boolean)
      .join(" ")
  );
};

export const getExamInstructionPath = (details) =>
  isBitsatExam(details) ? BITSAT_TEST_INSTRUCTION_PATH : "/TestInstruction";
